import { Action } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { isType } from "typescript-fsa";
import { isDateTimeAfter, isDateTimeBefore } from "../../utils/date";
import { campaignActions } from "./actions";
import { CampaignState } from "./types";

const initialState: CampaignState = {
  activeCampaign: null,
};

export function CampaignReducer(
  state = initialState,
  action: Action,
): CampaignState {
  if (isType(action, campaignActions.fetchActiveCampaign.started)) {
    return {
      ...state,
    };
  }

  if (isType(action, campaignActions.fetchActiveCampaign.done)) {
    const campaign = action.payload.result.campaign;
    if (!campaign) {
      return {
        ...state,
        activeCampaign: null,
      };
    }
    const later90DaysFromNow = dayjs().add(90, "day");
    const campaignSaleEndDate = dayjs(campaign.sale_end_date);
    return {
      ...state,
      activeCampaign: {
        id: campaign.id,
        name: campaign.name,
        description: campaign.description ?? "",
        image: campaign.image,
        startDate: campaign.start_date,
        endDate: campaign.end_date,
        saleStartDate: campaign.sale_start_date,
        saleEndDate: campaign.sale_end_date,
        minSaleStartDate:
          isDateTimeAfter(new Date(), campaign.end_date) ||
          isDateTimeBefore(new Date(), campaign.sale_start_date)
            ? campaign.sale_start_date
            : new Date(),
        maxSaleEndDate: campaignSaleEndDate.isBefore(later90DaysFromNow)
          ? campaignSaleEndDate.toDate()
          : later90DaysFromNow.toDate(),
        storeIds: campaign.store_ids,
        discountSettingId: campaign.discount_setting_id,
      },
    };
  }

  if (isType(action, campaignActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
